import { Injectable, inject } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { NotificationSnackbarComponent } from "../modules/core/notification-snackbar/notification-snackbar.component";

type NotificationSeverity = "success" | "info" | "warning" | "error";

@Injectable({
	providedIn: "root",
})
export class NotificationService {
	private snackBar = inject(MatSnackBar);

	success(message: string): void {
		this.open(message, "success");
	}

	info(message: string): void {
		this.open(message, "info");
	}

	warning(message: string): void {
		this.open(message, "warning");
	}

	error(message: string): void {
		this.open(message, "error");
	}

	private open(message: string, severity: NotificationSeverity): void {
		const config: MatSnackBarConfig<string> = {
			data: message,
			duration: 5000,
			// "end" rather than "right" so the snackbar mirrors under dir="rtl" (Arabic locale).
			horizontalPosition: "end",
			verticalPosition: "top",
			// "mitp-snack" carries the shared sizing, the severity class the colors.
			panelClass: ["mitp-snack", `mitp-snack-${severity}`],
		};

		this.snackBar.openFromComponent(NotificationSnackbarComponent, config);
	}
}
